import { render, staticRenderFns } from "./memberSecondPage.vue?vue&type=template&id=1a04435e&scoped=true&"
import script from "./memberSecondPage.vue?vue&type=script&lang=js&"
export * from "./memberSecondPage.vue?vue&type=script&lang=js&"
import style0 from "./memberSecondPage.vue?vue&type=style&index=0&id=1a04435e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a04435e",
  null
  
)

export default component.exports